import React from "react";
import { FilterPanel, Input } from "@aidkitorg/component-library";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useLocalizedStrings } from "../../../Localization";
import { useSettingsFilterFields } from "../../Filters/hooks/useSettingsFilterFields";
import { useFieldValueSuggestions } from "../../shared/hooks/useFieldValueSuggestions";

export type ApplicantCountFormFieldsProps = {
  title: string;
  setTitle: (val: string) => void;
  filterConfig?: ReportFilterConfig;
  setFilterConfig: (val: ReportFilterConfig | undefined) => void;
  setTitleHasError: (val: boolean) => void;
  isEditMode?: boolean;
};

export const ApplicantCountFormFields: React.FC<ApplicantCountFormFieldsProps> = ({
  title,
  setTitle,
  filterConfig,
  setFilterConfig,
  setTitleHasError,
  isEditMode = false,
}) => {
  const L = useLocalizedStrings()
  const availableFieldsForFilters = useSettingsFilterFields();
  const { fetchSuggestions } = useFieldValueSuggestions();

  return (
    <>
      <Input
        label={L.admin_panel.dashboards.metric_title}
        required
        maxLength={100}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onValidationChange={setTitleHasError}
      />

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {L.admin_panel.dashboards.filters_label}
        </label>
        <FilterPanel
          value={filterConfig}
          onChange={setFilterConfig}
          availableFields={availableFieldsForFilters}
          instanceId="applicant-count-form-filters"
          fetchFieldValues={fetchSuggestions}
          inline
        />
      </div>
    </>
  );
};